module.exports = __webpack_public_path__ + "assets/img/w_d_i_2.3830dabd.jpg";